module.exports = __webpack_public_path__ + "06_mole.8251dfb1.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/dad/layer2/06_mole.png
// module id = OiWJ
// module chunks = 0